import './css/gdpr.css';

import React, { Component } from 'react'
import {Icon} from 'semantic-ui-react'


export default class PageNavigation extends Component {
  state = { visible:  window.localStorage.getItem('hasseenGDPR') !=="1"}
  close = () => {
   window.localStorage.setItem('hasseenGDPR',"1")
   this.setState({ visible: false })
 }

 render() {
  const { visible } = this.state
  if(!visible) return null
  return (
    <div id="gdpr">
    <p>
    Las cookies y dispositivos de almacenamiento y recuperación de datos (DARD) son ficheros que se instalan en el dispositivo (ordenador, móvil, tablet) utilizado por el Usuario para acceder a www.grancanariaecologica.es y registrar su actividad. Este sitio web usa cookies y tecnologías equivalentes propias y de terceros con fines de seguridad, identificación de sesión, análisis estadístico, personalización y preferencias de la navegación, selección de idioma, gestión de espacios publicitarios, publicidad comportamental y personalizada, secuenciación y medición de impacto publicitario. Si cierra este aviso o continúa navegando sin desactivar las cookies y DARD, acepta que podamos alojar y utilizar las cookies y DARD descritos, en su dispositivo. Para desactivar las cookies y DARD consulte la Política de Cookies.
    </p>
    <Icon id="closegdpr" name="close" onClick={this.close}/>
    </div>
    )
}
}




// WEBPACK FOOTER //
// ./src/GDPRShit.js